import axios from './axios'

const createQueryString = (params, path) => {
  const queryString = Object.entries(params)
    .map(([key, value]) =>
      value ? `${encodeURIComponent(key)}=${encodeURIComponent(value)}` : null
    )
    .filter((item) => item)
    .join('&')
  return path + '?' + queryString
}

export const getBusinessAnalysis = (params) =>
  axios.get(createQueryString(params, '/business_report/business-analysis'))

export const sendBusinessReportEmail = (params) =>
  axios.post(createQueryString(params, '/business_report/business-analysis/send-email'))
